import { render, staticRenderFns } from "./DescriptionEditButton.vue?vue&type=template&id=b80f12a6"
import script from "./DescriptionEditButton.vue?vue&type=script&lang=js"
export * from "./DescriptionEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports